import React from 'react';
import {JobCost} from 'components/customer/Job/store/jobApi';
import {formatPrice} from 'shared/helpers';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';

interface CostBreakdownSimpleProps {
    cost: JobCost;
    isLoadingCost: boolean;
    isFetchingCost: boolean;
}

export const CostBreakdownSimple = ({
    cost,
    isLoadingCost,
    isFetchingCost,
}: CostBreakdownSimpleProps) => {
    const {job} = useJobContext() as PartialJob;

    if (cost) {
        return (
            <>
                <li>
                    <span>Job Subtotal:</span>
                    {!isLoadingCost || !isFetchingCost
                        ? formatPrice(cost.preliminaryJobCost, cost)
                        : '...'}
                </li>

                <li>
                    <span>{job?.countryTaxRateName}:</span>
                    <span>
                        {cost && (!isLoadingCost || !isFetchingCost)
                            ? formatPrice(cost.preliminaryTax, cost)
                            : '...'}
                    </span>
                </li>
                <li className="cost">
                    <span>Preliminary Cost:</span>
                    <span>
                        {cost && (!isLoadingCost || !isFetchingCost)
                            ? formatPrice(cost.preliminaryJobCostInclTax, cost)
                            : '...'}
                    </span>
                </li>
            </>
        );
    }
};
